import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	loading: false,
	panorama_node: null
};

export default function streetViewPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_STREET_VIEW_PANORAMA_NODE_BY_ID_REQUEST:
		case ActionTypes.GET_STREET_VIEW_PANORAMA_NODE_BY_ID_ERROR:
		case ActionTypes.GET_STREET_VIEW_PANORAMA_NODE_BY_ID_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_STREET_VIEW_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_STREET_VIEW_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
